export const pathRoutes = {
  home: "/",

  // Dashboard App
  transactions: "/transactions",
  insights: "/insights",
  contacts: "/contacts",
  accounts: "accounts",
  /* Keep the leading slash: without it links rendered inside `/contacts` resolve relative and produce `/contacts/contacts/accounts`. */
  contactsAccounts: "/contacts/accounts",
  buyers: "buyers",
  contactsBuyers: "/contacts/buyers",
  counterparties: "parties",
  merchants: "merchants",
  settings: "/settings",
  userRoles: "/roles",
  userRolesDetail: "/roles/:companyId/:roleId",
  marketplace: "/marketplace",
  productOffers: "product-offers",
  myProducts: "my-products",
  approvals: "/approvals",
  approvalDetail: "/approvals/:approvalId",
  approvalDefinitions: "/approval-definitions",

  // Business Insurance
  businessInsurance: "/businessInsurance",
  businessInsuranceCompanySelection: "/businessInsurance/companySelection",
  businessInsuranceBusinessArea: "/businessInsurance/businessArea",
  businessInsuranceCoverage: "/businessInsurance/coverage",
  businessInsuranceAddresses: "/businessInsurance/addresses",
  businessInsuranceAddressesBuilding: "/businessInsurance/addresses/building",
  businessInsuranceAddressesList: "/businessInsurance/addresses/list",
  businessInsuranceInventory: "/businessInsurance/inventory",
  businessInsuranceMachinery: "/businessInsurance/machinery",
  businessInsuranceLiability: "/businessInsurance/liability",
  businessInsuranceAdditionalCoverage: "/businessInsurance/additionalCoverage",
  businessInsuranceQuote: "/businessInsurance/quote",
  businessInsuranceContractDetails: "/businessInsurance/contractDetails",
  businessInsuranceInsurancePayment:
    "/businessInsurance/insurancePayment/:reqDocumentId",
  businessInsuranceDashboard:
    "/marketplace/businessInsurance/dashboard/:idLiveContractDocument",
  payablesActivation: "/marketplace/payables",

  // FlowPay Credit
  flowpayCredit: "/flowpayCredit",
  flowpayCreditCompanySelection: "/flowpayCredit/companySelection",
  flowpayCreditConsent: "/flowpayCredit/consent",
  flowpayCreditFinancialOverview: "/flowpayCredit/financialOverview",
  flowpayCreditDataSubmission: "/flowpayCredit/dataSubmission",
  flowpayCreditDashboard: "/marketplace/flowpayCredit/dashboard/:documentId",

  // Bibby Factoring
  bibbyFactoring: "/bibbyFactoring",
  bibbyFactoringCompanyDetails: "/bibbyFactoring/companyDetails",
  bibbyFactoringCustomerDetails: "/bibbyFactoring/customerDetails",
  bibbyFactoringKeyCustomers: "/bibbyFactoring/keyCustomers",
  bibbyFactoringRequest: "/bibbyFactoring/factoringRequest",
  bibbyFactoringReview: "/bibbyFactoring/review",
  bibbyFactoringThankYou: "/bibbyFactoring/thankYou/:reqDocumentId",

  // Roger Factoring
  rogerFactoring: "/rogerFactoring",
  rogerFactoringCompanyDetails: "/rogerFactoring/companyDetails",
  rogerFactoringCustomerDetails: "/rogerFactoring/customerDetails",
  rogerFactoringKeyCustomers: "/rogerFactoring/keyCustomers",
  rogerFactoringRequest: "/rogerFactoring/factoringRequest",
  rogerFactoringReview: "/rogerFactoring/review",
  rogerFactoringThankYou: "/rogerFactoring/thankYou/:reqDocumentId",

  // Malcom Factoring
  malcomFactoring: "/malcomFactoring",
  malcomFactoringCompanyDetails: "/malcomFactoring/companyDetails",
  malcomFactoringCustomerDetails: "/malcomFactoring/customerDetails",
  malcomFactoringKeyCustomers: "/malcomFactoring/keyCustomers",
  malcomFactoringRequest: "/malcomFactoring/factoringRequest",
  malcomFactoringReview: "/malcomFactoring/review",
  malcomFactoringThankYou: "/malcomFactoring/thankYou/:reqDocumentId",

  // Dashboard App > Company
  companyDetail: "/company/:companyId",
  accountDetail: "/company/:companyId/accounts/:accountId",
  companySettings: "/company/:companyId/settings",
  companySettingsTeam: "/company/:companyId/team",
  companySettingsConsents: "/company/:companyId/consents",
  companySettingsTerms: "/company/:companyId/terms",
  companySettingsTransactions: "/company/:companyId/transactions",
  companySettingsAccounting: "/company/:companyId/accounting",
  companySettingsAccountingCostCenters:
    "/company/:companyId/accounting/cost-centers",
  companySettingsAccountingDocumentSeries:
    "/company/:companyId/accounting/document-series",
  companySettingsAccountingContracts:
    "/company/:companyId/accounting/contracts",
  companySettingsAccountingActivities:
    "/company/:companyId/accounting/activities",
  companyApprovalRules: "/company/:companyId/approval-rules",
  companyApprovalRulesPayables: "/company/:companyId/approval-rules/payables",
  companyApprovalRuleSetNew: "/company/:companyId/approval-rules/payables/new",
  companyApprovalRuleSetDetail:
    "/company/:companyId/approval-rules/payables/:ruleSetId",
  companyApprovalRuleSetEdit:
    "/company/:companyId/approval-rules/payables/:ruleSetId/edit",
  companyTeamRoleComparison: "/company/:companyId/team/roles",
  companyUserSettings: "/company/:companyId/team/:userId/settings",
  companyAccounts: "/company/:companyId/accounts",
  companyUserSettingsWithRole:
    "/company/:companyId/team/:userId/settings/:roleId",
  companyPayables: "/company/:companyId/payables",
  companyReceivables: "/company/:companyId/receivables",
  companyReceivablesSetup: "/company/:companyId/receivables/setup",
  /* The buyer routes carry `:companyId` because the record belongs to one company, while the Kontakty list they open from spans all of them. */
  companyBuyerNew: "/company/:companyId/receivables/buyers/new",
  companyBuyerEdit: "/company/:companyId/receivables/buyers/:buyerId/edit",
  companyReceivablesSetupIdentity:
    "/company/:companyId/receivables/setup/identity",
  companyReceivablesSetupPaymentAccount:
    "/company/:companyId/receivables/setup/payment-account",
  companyReceivablesSetupDueDate:
    "/company/:companyId/receivables/setup/due-date",
  /* The draft route addresses a stored koncept rather than a mode of the form: `getDraft` is a point read by `draftId` and there is no list endpoint, so reopening one as the user left it has nothing to reopen from without the id in the path. */
  companyReceivablesInvoiceNew: "/company/:companyId/receivables/invoices/new",
  companyReceivablesInvoiceDraft:
    "/company/:companyId/receivables/invoices/drafts/:draftId",
  /* The číslo rather than the invoice id: readable, URL-safe by the pattern
     grammar, and never `new` or `drafts`, since every číslo has a counter. */
  companyReceivablesInvoiceDetail:
    "/company/:companyId/receivables/invoices/:invoiceNumber",
  /* A page rather than a dialog: the E3 form is a page, and the path gives
     the edit its own title and a reload-safe address (amend spec §8.1). */
  companyReceivablesInvoiceEdit:
    "/company/:companyId/receivables/invoices/:invoiceNumber/edit",
  // Invoicing settings sit with the other company-settings tabs (siblings of
  // /settings, like /accounting), not under /receivables — the surface is reached
  // from settings, and only its content belongs to AR.
  companySettingsInvoicing: "/company/:companyId/invoicing",
  companySettingsInvoicingAccounts: "/company/:companyId/invoicing/accounts",
  companySettingsInvoicingNumberSeries:
    "/company/:companyId/invoicing/number-series",
  companySettingsInvoicingDefaults: "/company/:companyId/invoicing/defaults",
  expenses: "/company/:companyId/expenses",
  analytics: "/company/:companyId/analytics",
  companyMyFidooCards: "/company/:companyId/my-fidoo/cards",
  companyPayablesInvoiceDetail:
    "/company/:companyId/payables/invoices/:invoiceId",
  companyPayablesExports: "/company/:companyId/payables/exports",
  inviteTeamMember: "/company/:companyId/invitation",
  inviteTeamMemberGlobal: "/invitation",

  // Join App (Onboarding)
  joinAppRoot: "/join/*",
  joinCompanyLookup: "/join/company-lookup",
  joinConnectBank: "/join/connect-bank",
  joinAuthorizeAccounts: "/join/authorize-accounts",
  joinInvite: "/join/invite",

  // OPS / Internal Portal App
  opsAppRoot: "/ops/*",
  opsCompaniesSearch: "/ops/companies",
  opsUsersSearch: "/ops/users",
  opsSelectRole: "/ops/select-role",

  // OPS / Person detail
  opsPersonDetailOverview: "/ops/users/:userId/overview",
  opsPersonDetailConsents: "/ops/users/:userId/consents",

  // OPS / Company detail
  opsClientsCompanyProfileOverview: "/ops/companies/:documentId/overview",
  opsClientsCompanyProfileAccounts: "/ops/companies/:documentId/accounts",
  opsClientsCompanyProfileContracts: "/ops/companies/:documentId/contracts",
  opsClientsCompanyProfileAccountDetail:
    "/ops/companies/:documentId/accounts/:bankAccountId",

  // OPS / Onboarding
  opsOnboarding: "/ops/onboarding",
  opsOnboardingDetail: "/ops/onboarding/:documentId",
  opsOnboardingReview: "/ops/onboarding/:documentId/review",
  opsSettings: "/ops/settings",

  // Redirect Gateway
  mobileAppGateway: "/mobile-gateway/redirect/:documentId",
  mobileCharts: "/mobile-charts/*",
  sessionTransfer: "/session-transfer",

  // Signup App
  signup: "/signup",
} as const;

export type PathRoutes = (typeof pathRoutes)[keyof typeof pathRoutes];
